import styled from '@emotion/styled'

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.18px;
  color: white;
  margin: 0;
`
